import React, { useState, useEffect } from "react";
// @material-ui/core components
import { Grid, Tabs, Tab } from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../assets/jss/components/tableStyle";
import styles from "../../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../../properties/Locale";
import ProfessionalTitleTypeComponent from "./professionalTitleType/ProfessionalTitleTypeComponent";
import ProfessionalTitleAreaComponent from "./professionalTitleArea/ProfessionalTitleAreaComponent";
import ProfessionalTitleSchemaPointComponent from "./professionalTitleSchemaPoint/ProfessionalTitleSchemaPointComponent";

const useStyles = makeStyles(styles, tableStyles);

export default function ProfessionalTitleConfigComponent(props) {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };
  return (
    <div>
      <Grid container style={{ paddingTop: "25px" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={LOCALE.professional_title_type} />
          <Tab label={LOCALE.professional_title_area} />
          <Tab label={LOCALE.schema_points} />
        </Tabs>
        {tabIndex === 0 && (
          <ProfessionalTitleTypeComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
        {tabIndex === 1 && (
          <ProfessionalTitleAreaComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
        {tabIndex === 2 && (
          <ProfessionalTitleSchemaPointComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
      </Grid>
    </div>
  );
}
